
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../lib/util'
import AbpBase from '../lib/abpbase'
@Component
export default class wjdcVue extends AbpBase {
handleChange(){
     let todayYqPath=this.$router.resolve({
            path:'/yuqing',
       })
       window.open(todayYqPath.href, '_blank');
}
}
